export enum ReferralStatus {
  INVITED = 'Invited',
  SUBSCRIBED = 'Subscribed'
}
